export default {
  container: {
    fontSize: '90px',
    width: '1em',
    height: '1em',
    borderRadius: '100%',
    backgroundColor: '#ccc'
  }
}
